<template>
  <button :class="cls" @click="showHide" ref="button">
    {{ title }}
    <i title="לא נצפה" class="mdi mdi-menu-down"></i>
    <div class="close-options" v-if="show"><button>סגור</button></div>
    <transition name="options-fade">
      <div class="dropdown-options-container" v-if="show">
        <div class="dropdown-options">
          <div class="top1" v-bind:style="top1">
            <img src="@/assets/images/top1.png" alt="" />
          </div>
          <span
            :class="optionCls(item.id)"
            v-for="item in item.includes"
            :key="item.id"
            @click="toggleOption(item)"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </transition>
  </button>
</template>

<script>
export default {
  props: {
    item: Object,
    show: Boolean,
    cols: Number,
  },
  data() {
    return {
      // show: false,
      active: [],
      width: 0,
    };
  },
  methods: {
    showHide(e) {
      if (e.target.classList[0] !== "dropdown-option") {
        if (
          e.target.classList[0] === "dropdown-btn" ||
          e.target.classList[0] === "mdi"
        ) {
          // this.show = !this.show;
          if (!this.show) {
            this.$emit("show-options");
          } else {
            this.$emit("close-options");
          }
        }
      }
    },
    toggleOption(option) {
      if (this.isActive(option.id)) {
        this.active = this.active.filter(item => {
          return item.id !== option.id;
        });
      } else {
        this.active.push(option);
      }
      this.$emit("option-selected", this.active);
    },
    isActive(id) {
      const list = this.active.filter(item => {
        return item.id === id;
      });
      if (list.length > 0) {
        return true;
      }
      return false;
    },
    optionCls(id) {
      if (this.isActive(id)) {
        return "dropdown-option active";
      }
      return "dropdown-option";
    },
  },
  watch: {
    item() {
      if (this.active.length === 0 && this.item.selected.length > 0) {
        this.item.selected.forEach(value => {
          this.active.push(value);
        });
      }
    },
  },
  computed: {
    title() {
      if (this.active.length === 0) {
        return this.item.title;
      }
      if (this.active.length === 1) {
        return `${this.active[0].label}`;
      }
      return `${this.item.title} (${this.active.length})`;
    },
    cls() {
      if (this.cols && this.cols === 1) {
        return "dropdown-btn dropdown-single";
      } else {
        if (this.width > 320) {
          return "dropdown-btn";
        }
        return "dropdown-btn dropdown-btn-narrow";
      }
    },
    top1() {
      return {
        width: this.width + "px",
      };
    },
  },
  mounted() {
    if (this.active.length === 0 && this.item.selected.length > 0) {
      this.item.selected.forEach(value => {
        this.active.push(value);
      });
    }
    if (this.$refs.button.scrollWidth) {
      this.width = this.$refs.button.scrollWidth;
    }
  },
};
</script>

<style lang="scss">
.dropdown-btn {
  position: relative;
  padding: 0.5rem;
  font-size: 1.125rem;
  background-color: #ffffff;
  display: block;
  width: 100%;
  border: 0;
  cursor: pointer;
  transition: all 200ms ease;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
  &:focus {
    border: 0;
    outline: none;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  }
  &:hover {
    color: #fd7170;
  }
  .mdi {
    position: absolute;
    left: 5px;
    top: 0;
    bottom: 0;
    font-size: 1.5rem;
    line-height: 2.5rem;
    transform: scale(1.2);
  }

  .close-options {
    position: fixed;
    bottom: 144px;
    height: 42px;
    right: 0;
    left: 0;
    padding: 0.5rem 0;
    background-color: #eee;
    display: flex;
    z-index: 25;
    button {
      color: #3273dc;
      background-color: transparent;
      border: 0;
      padding-bottom: 0.5rem;
    }
  }
}
.dropdown-options-container {
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  height: 144px;
  padding-top: 0.5rem;
  z-index: 20;
  overflow: auto;
  background-color: #f6f6f6;
}
.dropdown-options {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #f6f6f6;
  color: black;
  width: 100%;
  z-index: 30;
  padding: 1rem;
  &:hover {
    color: black;
  }
  .dropdown-option {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 1.125rem;
    padding: 0.3rem 0.5rem;
    color: #000000;
    border-bottom: 0.3px solid #a2a2a2;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
      background-color: #eee;
    }
  }
  .dropdown-option.active {
    color: #4c92fb;
    font-weight: bold;
  }
  .top1 {
    display: none;
  }
}

.options-fade-enter-active,
.options-fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.options-fade-enter,
.options-fade-leave-to {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

@media screen and (min-width: 1024px) {
  .dropdown-btn-narrow {
    .dropdown-options {
      width: 550px;
    }
  }
}

@media screen and (min-width: 769px) {
  .dropdown-btn {
    .close-options {
      display: none;
    }
  }
  .dropdown-options-container {
    position: absolute;
    top: 37px;
    right: 0;
    padding-top: 0;
    height: auto;
    overflow: visible;
    background-color: transparent;
  }

  .dropdown-options {
    top: 20px;
    min-height: 120px;
    background-color: #ffffff;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
    .top1 {
      display: block;
      position: absolute;
      top: -17px;
      right: 0;
      z-index: 35;
      width: 100%;
      text-align: center;
      img {
        width: 30px;
        height: auto;
      }
    }
    .dropdown-option {
      width: 45%;
      text-align: right;
      color: #adaaaa;
      border-color: #eeeeee;
    }
  }
}
</style>
  